import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import * as shared from '../assets/shared.module.scss';
import * as findWorkClasses from '../find_works/classes.module.scss';
import * as classes from './styles.module.scss';

const FavoriteWallCard = ({
  id, name, imageUrl, itemCount, onAdd
}) => (
  <div className={ classes.card }>
    <div className={ classes.image }>
      { imageUrl ? (
        <img src={ imageUrl } alt={ name } />
      ) : null }
    </div>
    <div className={ classes.inner }>
      <div className={ findWorkClasses.title }>
        <div className={ shared.title }>
          <strong>{ name }</strong>
          <span>
            { itemCount }
            {' '}
            items
          </span>
        </div>
      </div>
      <div className={ classes.wallSizes }>
        <Button
          size="mini"
          type="button"
          onClick={ (e) => {
            e.stopPropagation();
            onAdd(id);
          } }
        >
          Add
        </Button>
      </div>
    </div>
  </div>
);

FavoriteWallCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  itemCount: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired
};

FavoriteWallCard.defaultProps = {
  imageUrl: null
};

export default FavoriteWallCard;
